import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { frontloadConnect } from 'react-frontload';


import TireDetailMeta from './TireDetailMeta';
import ProductImages from '../ProductDetail/ProductImages';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import { trackDataLayer, trackEvent, trackPDSCheckoutStart } from '../../components/Tracking/Matomo';
import ReduxSuspense from '../../components/ReduxSuspense/ReduxSuspense';
import DealerInfo from '../../components/DealerInfo/DealerInfo';
import LegacyTireLabel from '../../components/Tires/LegacyTireLabel';

import { fetchWheelDetailIfNeeded } from '../../../modules/actions/standort/wheelDetail';
import { wheelDetailResponseSelector } from '../../../modules/selectors/standort/wheelDetail';
import Currency from '../../../helpers/currency';
import { taxLabel } from '../../../helpers/taxHelper';
import { speedIndexToSpeed } from '../../../helpers/tiresHelper';
import Meisterkachel from '../../components/Meisterkachel/Meisterkachel';
import Button from '../../components/form-elements/Button';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import Anchor from '../../components/form-elements/Anchor';
import withStandortRouter from '../../components/VHost/withStandortRouter';
import { InternalLink } from '../../components/form-elements/Link';
import { addReifen, deleteOneClickCart, validateArticleBeforePaypalOneClick, validateCartBeforeCheckout } from '../../../modules/actions/standort/session/cart';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { useHistory } from 'react-router-dom';
import { saveproduct, resetproduct } from '../../../modules/actions/productID';
import QuantityInput from '../ProductDetail/QuantityInput';
import classnames from 'classnames';
import { Offcanvas } from '../../components/Offcanvas/Offcanvas';
import { apiClient, useAsyncFunction } from '../../../helpers/apiHelperV2';
import { standortUrlSelector } from '../../../modules/selectors/url';
import MoreProductsSlider from '../ProductDetail/MoreProductsSlider';
import MoreProductsSliderCard from '../ProductDetail/MoreProductsSliderCard';
import InlineSpinner from '../../components/Spinner/InlineSpinner';
import _ from 'lodash';
import Image from '../../components/Image/Image';
import DeliveryCountdown from '../ProductDetail/DeliveryCountdown';
import StandortLink from '../../components/VHost/StandortLink';

import { toast } from '../../../helpers/toastHelper';
import { createPayPalOrder } from '../../../helpers/CheckoutHelper';
import { get, has } from 'lodash';
import { sessionIdSelector, userSelector } from '../../../modules/selectors/auth';
import { trackPinterestEvent } from '../../components/Tracking/Pinterest';
import { RESET_PAYPAL_ONCLICK_SESSION } from '../../../modules/actionTypes';
import { PayPalButtons, PayPalMessages } from '@paypal/react-paypal-js';
import { ExternalLink } from '../../components/form-elements/Link';

// TODO: merge/refactor with ProductDetail QuantityBox
function QuantityBox({ tire, online: isOnline, lieferweg, price, isFreeShipping, setSelect, isSelected, quantity, isOfferActive, isNoa }) {
    let aktionsPreis = tire.aktionsPreis ?? null;
    let aktionsPreisPickup = tire.aktionsPreisPickup ?? null;
    return (
        <div >
            <div onClick={() => setSelect(isOnline)} className={classnames('uk-width-1 uk-margin-small', isSelected ? "uk-background-muted quality-box-card" : "uk-border uk-border-muted quality-box-card")} style={{ cursor: 'pointer' }}>
                <div className="uk-flex uk-flex-between">
                    <div className="uk-text-small uk-text-muted uk-flex uk-flex-start">
                        <div className="uk-width-auto" style={{ paddingTop: "10px" }}>
                            <input type="radio" name={`lieferweg-${tire.id}`} className="uk-radio uk-margin-right" checked={isSelected} onChange={() => { }} />

                        </div>
                        <div>
                            <span className='uk-text-left uk-text-bold' style={{ fontSize: '1.375rem' }}>{isOnline ? 'Lieferung' : 'Abholung'}</span>
                            <div className='uk-margin-small'>
                                Preis inkl. {taxLabel()} MwSt.
                            </div>
                            {isOnline && (
                                isFreeShipping ?
                                    <div>
                                        <InternalLink to="/versandkosten" ariaLabel="Informationen zu Versandkosten"><u className='uk-text-bold uk-text-decoration-none' style={{ color: "#128001" }}>Versandkostenfrei</u></InternalLink>
                                    </div>
                                    :
                                    <div>
                                        zzgl. <Currency quantity={lieferweg?.versandkosten?.pauschale1} />{' '}
                                        <StandortLink
                                            className="uk-link focus"
                                            to="/lieferUndVersand"
                                            ariaLabel="Informationen zu Versandkosten"
                                        >
                                            <u>Versandkosten</u>
                                        </StandortLink>
                                    </div>
                            )}
                        </div>
                    </div>
                    {((!aktionsPreis && !aktionsPreisPickup) || !isOfferActive) &&
                        <span className="aps-price">
                            <Currency quantity={price * quantity} />
                        </span>
                    }

                    {(aktionsPreis && isOnline && isOfferActive) &&
                        <>
                            <div className="uk-width-2-3 uk-flex uk-flex-column uk-text-right uk-width-expand uk-padding-remove-left">
                                <div className="uk-flex uk-flex-middle uk-flex-column uk-flex-end">
                                    <div className="uk-width-auto uk-flex uk-flex-column uk-text-right uk-width-expand">
                                        <div className={classnames(isNoa ? "uk-flex uk-flex-end uk-flex-right noaOldPrice" : "uk-flex uk-flex-column uk-flex-middle uk-flex-right")}>
                                            <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom uk-padding-remove-left uk-padding-remove-vertical">
                                                <span className="statt">statt </span>
                                                <span>
                                                    <Currency quantity={price * quantity} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <span className={classnames('aps-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex uk-flex-middle uk-flex-center', { 'noaPrice': isNoa })}>
                                        {!isNoa && <span className='percentage uk-flex uk-flex-middle uk-flex-center' aria-label='rabattierter Artikel'>%</span>}
                                        <Currency quantity={aktionsPreis * quantity} />
                                    </span>
                                </div>
                            </div>
                        </>

                    }
                    {(aktionsPreisPickup && !isOnline && isOfferActive && price !== null) &&
                        <>
                            <div className="uk-width-2-3 uk-flex uk-flex-column uk-text-right uk-width-expand uk-padding-remove-left">
                                <div className="uk-flex uk-flex-middle uk-flex-column uk-flex-end">
                                    <div className="uk-width-auto uk-flex uk-flex-column uk-text-right uk-width-expand">
                                        <div className={classnames(isNoa ? "uk-flex uk-flex-end uk-flex-right noaOldPrice" : "uk-flex uk-flex-column uk-flex-middle uk-flex-right")}>
                                            <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom">
                                                <span className="statt">statt </span>
                                                <span>
                                                    <Currency quantity={price * quantity} />
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                    <span className={classnames('aps-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex uk-flex-middle uk-flex-center', { 'noaPrice': isNoa })}>
                                        {!isNoa && <span className='percentage uk-flex uk-flex-middle uk-flex-center' aria-label='rabattierter Artikel'>%</span>}
                                        <Currency quantity={aktionsPreisPickup * quantity} />
                                    </span>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

function TirePaypalMessages({ tireDetail, quantity, isOnline }) {
    const markenStandort = useSelector(markenStandortSelector);

    if (markenStandort?.paypalPayLaterMessages && isOnline) {
        return (
            <div className='uk-padding-small uk-padding-remove-left'>
                <PayPalMessages forceReRender={[tireDetail, quantity]} amount={(isOnline ? tireDetail.selectedBezugsquelle.onlineVK : tireDetail.selectedBezugsquelle.vk_preis) * quantity * 100} currency='EUR' placement='product' />
            </div>
        )
    } else {
        return null;
    }

}

function TireDetail({ tireDetail }) {
    const markenStandort = useSelector(markenStandortSelector);
    const focusBtnRef = useRef();
    const dispatch = useDispatch();
    const history = useHistory();
    const [quantity, setQuantity] = useState(1);
    const [paypalOneClickSessionId, setPaypalOneClickSessionId] = useState(null);
    const sessionId = useSelector(sessionIdSelector);
    const existingUser = useSelector(userSelector);
    const standortUrl = useSelector(standortUrlSelector);
    const topSellerResponse = useAsyncFunction(async () => apiClient.get(`/api/v1/standorte/${standortUrl}/bestseller`), [standortUrl]);
    const [isSidebarVisible, setSidebarVisible] = useState(false);
    const [offsetTop] = useState(130);
    const [isMobile, setIsMobile] = useState(null);
    const online = Boolean(tireDetail?.onlineLieferweg);
    const [isOnline, setIsOnline] = useState(online && !markenStandort.isTechno);

    const isNoa = markenStandort.gesellschafterNr === "035";
    const fahrzeugtyp = convertLegacyAutoTyp();
    const isTecar = tireDetail?.hersteller === 'TECAR' || tireDetail?.freeShipping === true;
    const onlinePrice = isOnline
        ? (tireDetail.aktionsPreis || tireDetail.selectedBezugsquelle.onlineVK)
        : tireDetail.selectedBezugsquelle.onlineVK;
    const pickupPrice = !isOnline
        ? (tireDetail.aktionsPreisPickup || tireDetail.selectedBezugsquelle.vk_preis)
        : tireDetail.selectedBezugsquelle.vk_preis;
    const herstellerangaben = tireDetail?.herstellerangaben ? tireDetail?.herstellerangaben : null;

    useEffect(() => {
        if (tireDetail) {
            let productID;
            productID = tireDetail.selectedBezugsquelle.artNummer;
            dispatch(saveproduct(productID));
        }
    }, [dispatch, tireDetail]);

    useEffect(() => {
        trackDataLayer({
            eventName: "view_product",
            products: [tireDetail],
            standort: markenStandort,
            value: (
                isOnline
                    ?
                    (tireDetail?.aktionsPreis ?? tireDetail?.selectedBezugsquelle?.onlineVK) * quantity
                    :
                    (tireDetail?.aktionsPreisPickup ?? tireDetail?.selectedBezugsquelle?.vk_preis) * quantity
            ),
            isOnline,
        })
        dispatch({
            type: RESET_PAYPAL_ONCLICK_SESSION,
        })
    }, []);

    useEffect(() => {
        if (tireDetail) {
            let productID;
            productID = tireDetail.selectedBezugsquelle.artNummer;
            dispatch(saveproduct(productID));
        }
    }, [dispatch, tireDetail]);

    useEffect(() => {
        trackDataLayer({
            eventName: "view_product",
            products: [tireDetail],
            standort: markenStandort,
            value: (
                isOnline
                    ?
                    (tireDetail?.aktionsPreis ?? tireDetail?.selectedBezugsquelle?.onlineVK) * quantity
                    :
                    (tireDetail?.aktionsPreisPickup ?? tireDetail?.selectedBezugsquelle?.vk_preis) * quantity
            ),
            isOnline,
        })
        dispatch({
            type: RESET_PAYPAL_ONCLICK_SESSION,
        })
        function handleResize() {
            setIsMobile(window.innerWidth < 640);
        }

        if (typeof window !== 'undefined') {
            handleResize();
        }

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Track eigene Artikel page views on tire PDP visit (independent of wheelDetail cache)
    useEffect(() => {
        const isOwnArticle = tireDetail?.isOwnArticle;
        const ownArticleId = tireDetail?._id;
        if (!standortUrl || !isOwnArticle || !ownArticleId) {
            return;
        }

        apiClient
            .post(`/api/v1/standorte/${standortUrl}/ownArticlePageViews`, {
                ownArticleId,
                shownId: tireDetail?.shownId || tireDetail?.selectedBezugsquelle?.artNummer,
            })
            .catch(err => {
                console.error('Failed to track own article page view', err);
            });
    }, [standortUrl, tireDetail?.isOwnArticle, tireDetail?._id, tireDetail?.shownId, tireDetail?.selectedBezugsquelle?.artNummer]);

    useEffect(() => {
        setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
    }, [sessionId])

    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            // ... logic
            dispatch(resetproduct());
        });

        return unlisten;
    }, [dispatch, history]);

    useEffect(() => {
        if (isSidebarVisible && focusBtnRef.current) {
            focusBtnRef.current.focus();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [isSidebarVisible]);

    const deliveryTime = useMemo(() => {
        if (!tireDetail) return false;

        const { deliveryDaysFrom, deliveryDaysTo } = tireDetail;

        if (deliveryDaysFrom > 0 && deliveryDaysTo > 0) {
            return `${deliveryDaysFrom}-${deliveryDaysTo} Werktage`;
        }

        if (deliveryDaysFrom === 1) {
            return `${deliveryDaysFrom} Werktag`;
        } else if (deliveryDaysFrom > 0) {
            return `${deliveryDaysFrom} Werktage`;
        }


        if (deliveryDaysTo === 1) {
            return `${deliveryDaysTo} Werktag`;
        } else if (deliveryDaysTo > 0) {
            return `${deliveryDaysTo} Werktage`;
        }

        return '3-10 Werktage';

    }, [tireDetail]);

    const pickupTime = useMemo(() => {
        if (!tireDetail) return false;

        const { pickupDaysFrom, pickupDaysTo } = tireDetail;

        if (pickupDaysFrom > 0 && pickupDaysTo > 0) {
            return `${pickupDaysFrom}-${pickupDaysTo} Werktagen`;
        }

        if (pickupDaysFrom === 1) {
            return `${pickupDaysFrom} Werktag`;
        } else if (pickupDaysFrom > 0) {
            return `${pickupDaysFrom} Werktagen`;
        }

        if (pickupDaysTo === 1) {
            return `${pickupDaysTo} Werktag`;
        } else if (pickupDaysTo > 0) {
            return `${pickupDaysTo} Werktagen`;
        }

        return '3-10 Werktagen';

    }, [tireDetail]);

    const soldOut = useMemo(() => {
        if (!tireDetail) return false;

        return (
            (tireDetail.stockkeeping && tireDetail.stock < 1 && tireDetail.stock !== null) ||
            tireDetail.soldOut
        );
    }, [tireDetail]);

    const isFreeShipping = useMemo(() => {
        let freeShipping = tireDetail?.isFreeShipping || isTecar;
        let activeSalePrice = (isOnline ? onlinePrice : pickupPrice) * quantity;
        let freeShippingThreshold = tireDetail.onlineLieferweg?.versandkosten?.freiAb;

        return freeShipping || activeSalePrice >= freeShippingThreshold

    }, [tireDetail, quantity]);

    const closeSidebar = useCallback(() => {
        setSidebarVisible(false);
    }, []);

    function convertLegacyAutoTyp() {
        return tireDetail.fahrzeugtyp === 'PKW' ? 'PKW' : tireDetail.fahrzeugtyp === 'LLKW' ? 'LLKW' : tireDetail.fahrzeugtyp === 'OR/SUV' ? 'SUV' : null;
    }

    const additionalCrumbs = [
        { url: `/reifen-felgen`, label: 'Reifen & Felgen' },
        {
            url: `/${tireDetail?.saison.toLowerCase()}reifen`,
            label: `${tireDetail?.saison}reifen`,
        },
        {
            url: `/reifen/${fahrzeugtyp}/${tireDetail?.saison}/${tireDetail?.breite}/${tireDetail?.querschnitt}/${tireDetail?.durchmesser}`,
            label: 'Reifenauswahl',
        },
        {
            label: 'Reifen',
        },
    ];

    const additionalInformation = tireDetail?.additionalInfo?.dotWare
        ? { label: `DOT: ${tireDetail.additionalInfo.dotWare}`, tooltip: 'DOT = Herstellungsjahr des Reifens' }
        : tireDetail?.additionalInfo?.herstellerGarantie
            ? { label: 'mit Herstellergarantie', tooltip: 'Spezielle Garantie des Herstellers' }
            : undefined;
    const vorteile = tireDetail?.onlineLieferweg?.Vorteilskommunikation ?? tireDetail?.pickupLieferweg?.Vorteilskommunikation ?? [];

    function getDeliveryAddress(paypalAuthorize) {
        const lastName = get(paypalAuthorize, 'purchase_units[0].shipping.name.full_name', '').split(' ').slice(-1).pop();
        const country = has(paypalAuthorize, 'purchase_units[0].shipping.address.country_code')
            ? get(paypalAuthorize, 'purchase_units[0].shipping.address.country_code', '')
            : get(paypalAuthorize, 'payer.name.address.country_code', '');

        if (country !== 'DE') {
            throw new Error('Bestellungen außerhalb Deutschlands werden nicht unterstützt.');
        }

        return {
            city: has(paypalAuthorize, 'purchase_units[0].shipping.address.admin_area_2')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.admin_area_2', '')
                : get(paypalAuthorize, 'payer.name.address.admin_area_2', ''),
            zipCode: has(paypalAuthorize, 'purchase_units[0].shipping.address.postal_code')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.postal_code', '')
                : get(paypalAuthorize, 'payer.name.address.postal_code', ''),
            street: has(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_1')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_1', '')
                : get(paypalAuthorize, 'payer.name.address.address_line_1', ''),
            additionalAddressInfo: has(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_2')
                ? get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_2', '')
                : get(paypalAuthorize, 'payer.name.address.address_line_2', ''),
            country: 'Deutschland',
            lastName: lastName,
            firstName: get(paypalAuthorize, 'purchase_units[0].shipping.name.full_name', '').split(lastName).join('').trim(),
        };
    }

    function getInvoiceAddress(paypalAuthorize) {
        const country = has(paypalAuthorize, 'payer.name.address.country_code')
            ? get(paypalAuthorize, 'payer.name.address.country_code', '')
            : get(paypalAuthorize, 'purchase_units[0].shipping.address.country_code', '');

        if (country !== 'DE') {
            throw new Error('Bestellungen außerhalb Deutschlands werden nicht unterstützt.');
        }

        return {
            city: has(paypalAuthorize, 'payer.name.address.admin_area_2')
                ? get(paypalAuthorize, 'payer.name.address.admin_area_2', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.admin_area_2', ''),
            zipCode: has(paypalAuthorize, 'payer.name.address.postal_code')
                ? get(paypalAuthorize, 'payer.name.address.postal_code', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.postal_code', ''),
            street: has(paypalAuthorize, 'payer.name.address.address_line_1')
                ? get(paypalAuthorize, 'payer.name.address.address_line_1', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_1', ''),
            additionalAddressInfo: has(paypalAuthorize, 'payer.name.address.address_line_2')
                ? get(paypalAuthorize, 'payer.name.address.address_line_2', '')
                : get(paypalAuthorize, 'purchase_units[0].shipping.address.address_line_2', ''),
            country: 'Deutschland',
            lastName: get(paypalAuthorize, 'payer.name.surname', ''),
            firstName: get(paypalAuthorize, 'payer.name.given_name', ''),
            payerId: get(paypalAuthorize, 'payer.payer_id', ''),
        };
    }

    let createOrder = async (data, actions) => {

        return await dispatch(addReifen({
            reifen: {
                ...tireDetail,
                selectedLieferweg: isOnline ? tireDetail.onlineLieferweg : tireDetail.pickupLieferweg,
                selectedBezugsquelle: {
                    ...tireDetail.selectedBezugsquelle,
                    vk_preis: isOnline ? onlinePrice : pickupPrice,
                },
            },
            quantity,
            buttonType: "paypalOneClick",
            paypalOneClickSessionId

        })).then(async result => {
            if (!result?.error && result?.data) {
                trackPDSCheckoutStart({ legalType: 'online-kauf-pds' });
                trackDataLayer({
                    eventName: "begin_checkout",
                    products: [Object.assign(tireDetail, { quantity: quantity })],
                    standort: markenStandort,
                    value: (
                        isOnline
                            ?
                            (tireDetail?.aktionsPreis ?? tireDetail?.selectedBezugsquelle?.onlineVK) * quantity
                            :
                            (tireDetail?.aktionsPreisPickup ?? tireDetail?.selectedBezugsquelle?.vk_preis) * quantity
                    ),
                    isOnline
                })
                trackPinterestEvent('checkout', {
                    legalType: 'online-kauf',
                });
                return actions.order.create(createPayPalOrder({ cart: result.data, hasNoShipping: false }));
            }
        })
    }

    async function approveOrder(data, actions) {
        try {
            const paymentDetails = await actions.order.get();
            let cart = await apiClient.get(`/api/v1/standorte/${standortUrl}/carts/${paypalOneClickSessionId}`).then(result => {
                return result.data.data
            });

            const deliveryAddress = getDeliveryAddress(paymentDetails);
            const invoiceAddress = getInvoiceAddress(paymentDetails);

            const { data: user } = await apiClient.post('/api/v1/checkout/paypal/user', {
                existingUser,
                userData: paymentDetails,
                standortUrl,
            });
            let checkoutData = {
                payment: {
                    paymentDetails: paymentDetails,
                    paymentProvider: 'PayPal',
                    completed: true,
                },
                cart: {
                    ...cart,
                    products: cart.products.map(p => {
                        return {
                            ...p,
                            selectedLieferweg: {
                                ...(p.selectedLieferweg || {}),
                                type: 'paypalVersand',
                                paymentType: 'paypalVersand',
                            },
                        };
                    }),
                },
                userdata: {
                    deliveryAddress,
                    invoiceAddress,
                    infoEmail: get(paymentDetails, 'payer.email_address', ''),
                    completed: true,
                },
                user: user.data._id,
            };

            await apiClient.post('/api/v1/checkout/InitializePaypalCheckout', {
                products: cart.products,
                cart,
                standortUrl,
                selectedSublocation: null,
                type: 'online-kauf',
                sessionId: cart.sessionId,
                checkoutData,
            });

            const { data: nextUrl } = await apiClient.post('/api/v1/getNextCheckoutUrl/adresse', {
                sessionId: cart.sessionId,
            });

            if (nextUrl.data.redirectUrl) history.push(nextUrl.data.redirectUrl);
        } catch (err) {
            setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
            await dispatch(deleteOneClickCart({ paypalOneClickSessionId }))
            toast({ err, message: 'Fehler beim Abschicken der Bestellung, bitte wenden Sie sich an den Support.' });
        } finally {
            // setLoading(false);
        }
    }

    async function onError(err) {
        setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
        await dispatch(deleteOneClickCart({ paypalOneClickSessionId }))
        toast({ err, message: 'Fehler beim Abschicken der Bestellung' });
    }

    async function onCancel(data) {
        setPaypalOneClickSessionId(sessionId + "-paypalOneClick-" + Date.now())
        await dispatch(deleteOneClickCart({ paypalOneClickSessionId }))
    }

    function onClick(data, actions) {
        if (soldOut || tireDetail?.deleted) {
            toast({
                message: 'Das gewählte Produkt ist aktuell nicht verfügbar.',
                status: 'warning',
            });
            return actions.reject();
        }

        return dispatch(
            validateArticleBeforePaypalOneClick({
                article: { ...tireDetail, elementType: 'reifen' },
                categoryUrl: 'reifen',
            })
        ).then(isValid => {
            if (!isValid) {
                return actions.reject();
            }
        });
    }

    function handleAddToCart({ quantity, buttonType }) {
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: tireDetail.neutralKey,
            value: (isOnline ? onlinePrice : pickupPrice) * quantity * 100,
        });
        trackDataLayer({
            eventName: "add_to_cart",
            products: [Object.assign(tireDetail, { quantity: quantity })],
            standort: markenStandort,
            value: (
                isOnline
                    ?
                    (tireDetail?.aktionsPreis ?? tireDetail?.selectedBezugsquelle?.onlineVK)
                    :
                    (tireDetail?.aktionsPreisPickup ?? tireDetail?.selectedBezugsquelle?.vk_preis)
            ),
            isOnline
        })
        dispatch(
            addReifen({
                reifen: {
                    ...tireDetail,
                    selectedLieferweg: isOnline ? tireDetail.onlineLieferweg : tireDetail.pickupLieferweg,
                    selectedBezugsquelle: {
                        ...tireDetail.selectedBezugsquelle,
                        vk_preis: isOnline ? onlinePrice : pickupPrice,
                    },
                    deliveryDays: isOnline ? deliveryTime : pickupTime,
                    deliveryText: isOnline ? `Lieferzeit: ${deliveryTime}` : `Abholbereit in: ${pickupTime}`,
                },
                quantity,
                buttonType
            })
        );
        setSidebarVisible(true);
    }
    const handleSelect = (isOnline) => {
        if (isOnline) {
            setIsOnline(true)
        } else {
            setIsOnline(false);
            // Handle offline selection
        }
    };
    const handleQuantityInputChange = (newQuantity) => {
        setQuantity(newQuantity);
    };

    const handlePress = (e) => {
        e.preventDefault()
        if (e.key === "Enter") {
            closeSidebar()
        }
    }


    const isAB = tireDetail.isAB;

    const isOfferActive = (tireDetail.isDeliveryOfferActive && !isAB) || (tireDetail.isPickUpOfferActive && (isAB || tireDetail.additionalPickup));

    const showMarketingText =
        tireDetail.productMarketingText &&
        tireDetail.productMarketingText !== '' &&
        tireDetail.productMarketingText !== 'undefined' &&
        !isMobile;

    const showMarketingTextMobile =
        tireDetail.productMarketingText &&
        tireDetail.productMarketingText !== '' &&
        tireDetail.productMarketingText !== 'undefined' &&
        isMobile;

    return (
        <>
            <TireDetailMeta tireDetail={tireDetail} />
            <BreadCrumbSelector additionalCrumbs={additionalCrumbs} />
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container uk-margin-medium-top">
                    <h1 className="uk-margin-remove">
                        {tireDetail.hersteller} {tireDetail.profil} <span className="uk-text-muted">{tireDetail.bezeichnung}</span>
                    </h1>
                    <h2 className="uk-text-light uk-margin-remove">{tireDetail.warengruppe}</h2>
                    <p>Artikelnummer: {tireDetail.selectedBezugsquelle.artNummer}</p>
                    <div className="uk-grid-small uk-child-width-1-2@s" data-uk-grid="">
                        <div>
                            <ProductImages variant={tireDetail} images={tireDetail.images || []} isOfferActive={isOfferActive} />
                            {herstellerangaben && !isMobile && (
                                <div className='uk-margin-large-bottom'>
                                    <span><strong>Herstellerangaben:</strong> </span>
                                    <span>
                                        {herstellerangaben?.firma ? `${herstellerangaben?.firma} | ` : ""}
                                        {herstellerangaben?.street ? `${herstellerangaben?.street} | ` : ""}
                                        {herstellerangaben?.city || herstellerangaben.zipCode ? `${herstellerangaben?.zipCode ?? ''} ${herstellerangaben?.city ?? ''} | ` : ""}
                                        {herstellerangaben?.phone ? `Tel: ${herstellerangaben.phone} | ` : ""}
                                        {herstellerangaben?.email ? <>E-Mail: <ExternalLink to={`mailto:${herstellerangaben.email}`}>{herstellerangaben.email}</ExternalLink> {herstellerangaben.homepage && ' | '} </> : ""}
                                        {herstellerangaben?.homepage ? <>Webseite: <ExternalLink to={`${herstellerangaben.homepage}`}>{herstellerangaben.homepage}</ExternalLink> </> : ""}
                                    </span>
                                </div>
                            )}
                            {showMarketingText ? (
                                <div>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: tireDetail.productMarketingText,
                                        }}
                                    />
                                </div>
                            ) : null}
                        </div>

                        <div>
                            <div className="uk-flex uk-flex-between uk-flex-middle uk-padding-small uk-padding-remove-top uk-padding-remove-left uk-padding-remove-right">
                                {isOnline && (
                                    tireDetail.expressDelivery ? (
                                        <DeliveryCountdown
                                            expressDeliveryTimeISO={tireDetail.expressDelivery}
                                        />
                                    ) : (
                                        !tireDetail.soldOut && deliveryTime && (
                                            <div className="uk-flex uk-flex-middle">
                                                <span className="uk-icon uk-icon-circle lieferzeit-icon-badge"></span>
                                                <span
                                                    className="uk-text-small uk-margin-small-left"
                                                    id="lieferzeit-hinweis"
                                                >
                                                    Lieferzeit {deliveryTime}
                                                </span>
                                            </div>
                                        )
                                    )
                                )}

                                {!tireDetail.soldOut && pickupTime && !isOnline && (
                                    <>
                                        <div className="uk-flex uk-flex-middle">
                                            <span className="uk-icon uk-icon-circle lieferzeit-icon-badge"></span>
                                            <span
                                                className="uk-text-small uk-margin-small-left"
                                                id="abholbereit-hinweis"
                                            >
                                                Abholbereit innerhalb von {pickupTime}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="uk-child-width-1-1 uk-grid-small" data-uk-grid="">
                                {tireDetail.onlineLieferweg && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.onlineVK}
                                        isOfferActive={isOfferActive}
                                        lieferweg={tireDetail.onlineLieferweg}
                                        online
                                        isFreeShipping={isTecar || isFreeShipping}
                                        setSelect={handleSelect}
                                        isSelected={isOnline}
                                        quantity={quantity}
                                        isNoa={isNoa}
                                    />
                                )}
                                {tireDetail.pickupLieferweg && !markenStandort.isTechno && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.vk_preis}
                                        isOfferActive={isOfferActive}
                                        lieferweg={tireDetail.pickupLieferweg}
                                        setSelect={handleSelect}
                                        isSelected={!isOnline}
                                        quantity={quantity}
                                        isNoa={isNoa}
                                    />
                                )}
                                <div className="uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s uk-first-column uk-padding-remove-left uk-margin-remove-left" data-uk-grid="">
                                    <div>
                                        <div className="uk-form-controls">
                                            <QuantityInput
                                                initialValue={1}
                                                minValue={1}
                                                maxValue={(!tireDetail.stock || tireDetail.stock > 999) ? 1111 : tireDetail.stock}
                                                onChange={handleQuantityInputChange}
                                                ariaLabel={`Menge festlegen. Minimum: 1, Maximum: ${(!tireDetail.stock || tireDetail.stock > 999) ? 1111 : tireDetail.stock}`}

                                            />
                                        </div>
                                        {(tireDetail.abcCategory === 'C') && (
                                            <div className="uk-text-small" style={{ color: 'var(--shop-main)' }}>
                                                Max. Bestellmenge: 4
                                            </div>
                                        )}
                                        {(tireDetail.abcCategory !== 'C' && tireDetail.stockkeeping && tireDetail.stock > 0) && (
                                            <div className="uk-text-small" style={{ color: 'var(--shop-main)' }}>
                                                Max. Bestellmenge: {tireDetail.stock}
                                            </div>
                                        )}
                                        <TirePaypalMessages tireDetail={tireDetail} quantity={quantity} isOnline={isOnline} />
                                    </div>
                                    <div>
                                        <Button disabled={soldOut} onClick={() => handleAddToCart({ quantity, buttonType: isOnline ? 'addToCart' : 'reserve' })} className='custom-button-qualityBox uk-width-1-1 uk-margin-small-bottom uk-text-uppercase' ariaLabel={isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}>{isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}</Button>
                                        {isOnline &&
                                            <PayPalButtons
                                                onClick={onClick}
                                                createOrder={createOrder}
                                                onApprove={approveOrder}
                                                onCancel={onCancel}
                                                onError={onError}
                                                fundingSource='paypal'
                                                style={{
                                                    tagline: false,
                                                    shape: 'sharp',
                                                    label: 'checkout',
                                                    height: 44,
                                                }}
                                            />
                                        }
                                    </div>
                                </div>

                                {tireDetail.energyLabelUrl && (
                                    <div className='energy-label-box'>
                                        <div className="energy-label-header">
                                            <div className='energy-label-title uk-text-bold uk-text-large'>EU-Reifenlabel-Werte</div>
                                            <TireInformationModal tire={tireDetail} adjusted={false} />
                                        </div>
                                        <div data-uk-grid="" className="uk-grid-small uk-child-width-expand@s">
                                            <TireEnergyLabelLinks tire={tireDetail} />
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <table className="uk-table uk-table-striped uk-table-small">
                                        <tbody>
                                            <tr>
                                                <td>Hersteller</td>
                                                <td>{tireDetail.hersteller}</td>
                                            </tr>
                                            {tireDetail.profil && (
                                                <tr>
                                                    <td>Profil</td>
                                                    <td>{tireDetail.profil}</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>Größe</td>
                                                {tireDetail.tireSize ? (
                                                    <td>{tireDetail.tireSize}</td>
                                                ) : (
                                                    <td>{tireDetail.bezeichnung}</td>
                                                )}
                                            </tr>
                                            <tr>
                                                <td>Geschwindigkeitsindex</td>
                                                <td>
                                                    {tireDetail.speedindex} bis {speedIndexToSpeed[tireDetail.speedindex]} km/h
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Loadindex</td>
                                                <td>{tireDetail.loadindex}</td>
                                            </tr>
                                            <tr>
                                                <td>Kategorie</td>
                                                {tireDetail.categoryType ? (
                                                    <td>{tireDetail.categoryType}</td>
                                                ) : (
                                                    <td>{tireDetail.warengruppe}</td>
                                                )}
                                            </tr>
                                            {additionalInformation && (
                                                <tr>
                                                    <td>Zusatzinformationen</td>
                                                    <td>
                                                        <div data-uk-tooltip={additionalInformation.tooltip}>
                                                            <i className="fa fa-info-circle" aria-hidden="true" />{' '}
                                                            {additionalInformation.label}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>Demontierte Reifen</td>
                                                <td>
                                                    {tireDetail?.additionalInfo?.demo ? 'Ja' : 'Nein'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className="uk-text-muted">Lieferung ohne Felge</p>
                                </div>
                                <div>
                                    {!tireDetail.energyLabelUrl && (
                                        <ul data-uk-accordion="">
                                            <li className="uk-open">
                                                <Anchor className="uk-accordion-title">EU-Reifenlabel</Anchor>
                                                <div className="uk-accordion-content">
                                                    <LegacyTireLabel tireDetails={tireDetail} />
                                                </div>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                                {herstellerangaben && isMobile && (
                                    <div className='uk-margin-large-bottom'>
                                        <span><strong>Herstellerangaben:</strong> </span>
                                        <span>
                                            {herstellerangaben?.firma ? `${herstellerangaben?.firma} | ` : ""}
                                            {herstellerangaben?.street ? `${herstellerangaben?.street} | ` : ""}
                                            {herstellerangaben?.city || herstellerangaben.zipCode ? `${herstellerangaben?.zipCode ?? ''} ${herstellerangaben?.city ?? ''} | ` : ""}
                                            {herstellerangaben?.phone ? `Tel: ${herstellerangaben.phone} | ` : ""}
                                            {herstellerangaben?.email ? <>E-Mail: <ExternalLink to={`mailto:${herstellerangaben.email}`}>{herstellerangaben.email}</ExternalLink> {herstellerangaben.homepage && ' | '} </> : ""}
                                            {herstellerangaben?.homepage ? <>Webseite: <ExternalLink to={`${herstellerangaben.homepage}`}>{herstellerangaben.homepage}</ExternalLink> </> : ""}
                                        </span>
                                    </div>
                                )}
                                {showMarketingTextMobile ? (
                                    <div>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: tireDetail.productMarketingText,
                                            }}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {false && (
                <section className="uk-section uk-section-muted uk-section-small">
                    <div className="uk-container">
                        <div className="uk-flex uk-flex-wrap uk-flex-center@m">
                            {vorteile.map((vorteil, i) => {
                                if (typeof vorteil === 'object') {
                                    return (
                                        <div className="uk-flex uk-flex-middle uk-margin-small-right uk-width-1-1 uk-width-auto@m" key={i}>
                                            <div
                                                className="uk-margin-small-right uk-font-main"
                                                dangerouslySetInnerHTML={{ __html: vorteil.path }}
                                            />
                                            {vorteil.text}
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div className="uk-flex uk-flex-middle uk-margin-small-right uk-width-1-1 uk-width-auto@m" key={i}>
                                            <i className="fa fa-check uk-margin-small-right uk-font-main" />
                                            {vorteil}
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </section>
            )}
            <section className="uk-section uk-section-muted uk-section-small">
                <div className="uk-container uk-container-xsmall">
                    <Meisterkachel />
                </div>
            </section>
            <DealerInfo />
            <Offcanvas overlay isVisible={isSidebarVisible} onIsVisibleChange={visible => setSidebarVisible(visible)} flip={true} className="side-bar-zindex">
                <div className="uk-offcanvas-bar product-sidebar" style={{ top: offsetTop, bottom: 0, overflowY: 'auto', WebkitOverflowScrolling: 'touch', paddingBottom: 'env(safe-area-inset-bottom, 16px)' }}>
                    <button className="uk-offcanvas-close focus" type="button" ref={focusBtnRef} data-uk-close="" onKeyPress={handlePress} onClick={closeSidebar} aria-label='Navigation schließen' aria-hidden="true" focusable="false" />
                    <span className='uk-text-bold menu-black'><i className="fa fa-check-circle" aria-hidden="true" style={{ color: "#128001" }} /> <span className='uk-margin-small-left'> Artikel wurde hinzugefügt</span></span>
                    <div className='uk-flex uk-flex-middle uk-margin-top'>
                        <div className='uk-margin-small-right'>
                            <Image src={tireDetail.images[0]} alt={tireDetail.bezeichnung} resizeHeight={120} fit="cover" />
                        </div>
                        <div className='uk-margin-small-left'>
                            <p className='headline headline-sidebar'>
                                {tireDetail.hersteller} {tireDetail.profil} <span className="uk-text-muted">{tireDetail.bezeichnung}</span>
                            </p>

                            {((!tireDetail.aktionsPreis && !tireDetail.aktionsPreisPickup) || !isOfferActive) && (
                                <span className="aps-price sidebar-price">
                                    <Currency quantity={(isOnline ? tireDetail.selectedBezugsquelle.onlineVK : tireDetail.selectedBezugsquelle.vk_preis) * quantity} />
                                </span>
                            )}

                            {(tireDetail.aktionsPreis && isOnline && isOfferActive) && (
                                <div className="uk-flex uk-flex-column">
                                    <div className={classnames(isNoa ? "uk-flex noaOldPrice" : "uk-flex uk-flex-column")}>
                                        <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom">
                                            <span className="statt">statt </span>
                                            <span>
                                                <Currency quantity={tireDetail.selectedBezugsquelle.onlineVK * quantity} />
                                            </span>
                                        </div>
                                    </div>
                                    <span className={classnames('aps-price sidebar-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex', { 'noaPrice': isNoa })}>
                                        {!isNoa && <span className='percentage uk-flex' aria-label='rabattierter Artikel'>%</span>}
                                        <Currency quantity={tireDetail.aktionsPreis * quantity} />
                                    </span>
                                </div>
                            )}

                            {(tireDetail.aktionsPreisPickup && !isOnline && isOfferActive && tireDetail.selectedBezugsquelle.vk_preis !== null) && (
                                <div className="uk-flex uk-flex-column">
                                    <div className={classnames(isNoa ? "uk-flex noaOldPrice" : "uk-flex uk-flex-column")}>
                                        <div className="uk-h6 aps-price-old uk-margin-remove-top uk-margin-remove-bottom">
                                            <span className="statt">statt </span>
                                            <span>
                                                <Currency quantity={tireDetail.selectedBezugsquelle.vk_preis * quantity} />
                                            </span>
                                        </div>
                                    </div>
                                    <span className={classnames('aps-price sidebar-price uk-text-offer uk-margin-remove-top uk-margin-remove-bottom uk-flex', { 'noaPrice': isNoa })}>
                                        {!isNoa && <span className='percentage uk-flex' aria-label='rabattierter Artikel'>%</span>}
                                        <Currency quantity={tireDetail.aktionsPreisPickup * quantity} />
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                    <hr />
                    <ReduxSuspense response={topSellerResponse} error={null} fallback={<InlineSpinner />}>
                        {data => {
                            if (_.isEmpty(data?.data)) return null;
                            return (
                                <section className="uk-section-default uk-padding-remove-bottom">
                                    <div className="uk-container uk-margin-medium-top">
                                        <p className='menu-black'><span>Jetzt gleich mitbestellen</span></p>
                                        <MoreProductsSlider>
                                            {data.data.map(product => (
                                                <li key={product.id}>
                                                    <MoreProductsSliderCard product={product} onClose={closeSidebar} />
                                                </li>
                                            ))}
                                        </MoreProductsSlider>
                                    </div>
                                </section>
                            );
                        }}
                    </ReduxSuspense>
                    <div className="uk-flex uk-flex-column uk-text-center uk-text-right@s uk-width-expand uk-padding-small uk-margin-top-small">
                        <Button
                            className={classnames('custom-button-qualityBox-default uk-text-uppercase')}
                            type="button"
                            modifier="default"
                            onClick={() => closeSidebar()}
                            ariaLabel='WEITER EINKAUFEN'
                        >
                            WEITER EINKAUFEN
                        </Button>

                        <InternalLink to="/warenkorb" fullWidth className="uk-margin-top uk-button uk-button-primary custom-button-qualityBox uk-text-uppercase" modifier="primary" ariaLabel="ZUM WARENKORB">
                            ZUM WARENKORB
                        </InternalLink>
                    </div>
                </div>
            </Offcanvas>
        </>
    );
}

function LoadTireDetail({ wheelDetailResponse }) {
    return <ReduxSuspense response={wheelDetailResponse}>{tireDetail => <TireDetail tireDetail={tireDetail} />}</ReduxSuspense>;
}

const frontload = async props => {
    const { fetchWheelDetailIfNeeded, wheelId } = props;
    await fetchWheelDetailIfNeeded({ wheelId });
};

const mapDispatchToProps = { fetchWheelDetailIfNeeded };

const mapStateToProps = (
    state,
    {
        match: {
            params: { id: wheelId },
        },
    }
) => {
    return { wheelId, wheelDetailResponse: wheelDetailResponseSelector(state, { wheelId }) };
};

export default withStandortRouter(
    connect(mapStateToProps, mapDispatchToProps)(frontloadConnect(frontload, { onUpdate: true })(LoadTireDetail))
);
